<p>
  <mat-form-field appearance="fill">
    <mat-select [(ngModel)]="device" [compareWith]="objectComparisonFunction">
      <mat-option *ngFor="let device of this.devices | keyvalue; index as i" [value]="device.value"> {{ device.value.label }} <mat-icon matSuffix>camera_alt</mat-icon></mat-option>
    </mat-select>
  </mat-form-field>
  <mat-dialog-actions align="end">
    <button class="btn-accept-user" id="mat-dialog-selectcamera" mat-button color="primary" [mat-dialog-close]="true" (click)="close()" >Select</button>
  </mat-dialog-actions>
</p>
